/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Error_MessageInputs */

const en_common_error_message = /** @type {(inputs: Common_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please try again.`)
};

const zh_common_error_message = /** @type {(inputs: Common_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`页面出现了一些问题，请重试。`)
};

/**
* | output |
* | --- |
* | "Something went wrong. Please try again." |
*
* @param {Common_Error_MessageInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_error_message = /** @type {((inputs?: Common_Error_MessageInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_MessageInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_error_message(inputs)
	return zh_common_error_message(inputs)
});
export { common_error_message as "common.error.message" }